require('../javascript');
import 'bootstrap';
require.context('../images/', true);